export default __webpack_public_path__ + "static/icon-e54b5f86cd08e64bf7ef8884f30420c5.png";